import React from "react";

export default props => {
    const dayNames = {
        0: "zondag",
        1: "maandag",
        2: "dinsdag",
        3: "woensdag",
        4: "donderdag",
        5: "vrijdag",
        6: "zaterdag",
    };

    const monthNames = {
        0: 'januari',
        1: 'februari',
        2: 'maart',
        3: 'april',
        4: 'mei',
        5: 'juni',
        6: 'juli',
        7: 'augustus',
        8: 'september',
        9: 'oktober',
        10: 'november',
        11: 'december',
    };

    const appointmentInThePast = appointment => {
        if (appointment.startTime.getHours() < new Date().getHours()) {
            return true;
        } else if (appointment.startTime.getHours() === new Date().getHours()) {
            if (appointment.startTime.getMinutes() <= new Date().getMinutes()) {
                return true;
            }
        }

        return false;
    }

    return (
        <div className={`day ${props.isToday ? "day--today" : ""}`}>
            <h4 className="day__day">{ dayNames[props.day.getDay()] }</h4>
            <h4 className="day__date">{ props.day.getDate().toString().slice(-2) }</h4>
            <h4 className="day__full">
                { dayNames[props.day.getDay()] } <strong>{ props.day.getDate().toString() } { monthNames[props.day.getMonth()] }</strong>
            </h4>
            <div className="day__appointments">
                { props.appointments.map( appointment =>
                    <button
                        className="day__appointment"
                        disabled={ props.isToday && appointmentInThePast(appointment) }
                        onClick={ () => props.clickHandler(appointment.appointmentId) }
                        key={ appointment.appointmentId }
                    >
                        {("0" + appointment.startTime.getHours()).slice(-2)}:{("0" + appointment.startTime.getMinutes()).slice(-2)}
                        {" - "}
                        {("0" + appointment.endTime.getHours()).slice(-2)}:{("0" + appointment.endTime.getMinutes()).slice(-2)}
                    </button>
                )}
            </div>
        </div>
    );
};

